import { useTranslation } from 'react-i18next';

export const useFormatters = () => {
    const { t } = useTranslation();

    const formatCurrency = (amount) => {
        let currencyLabel = t('common.currency');
        if (!currencyLabel || currencyLabel === 'Currency') {
            currencyLabel = (t('i18n.language') === 'ar' || t('i18n.language') === 'ar-EG') ? 'جنيه مصري' : 'EGP';
        }
        return new Intl.NumberFormat(t('i18n.language') === 'ar' ? 'ar-EG' : 'en-US', {
            style: 'currency',
            currency: 'EGP',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount || 0) + ` ${currencyLabel}`;
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString();
    };

    return {
        formatCurrency,
        formatDate
    };
};

// Static versions for use outside components
export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ar-EG', {
        style: 'currency',
        currency: 'EGP',
    }).format(amount || 0);
};

export const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
};